<template>
  <v-main>

    <v-container
        id="view-dependents-container"
        fluid
        tag="section"
    >

      <base-material-card
          icon="mdi-family-tree"
          class="px-5 py-3"
      >

        <div class="page-messages">
          <shared-page-messages :error-messages="errorMessages"
                                :warning-messages="warningMessages"
                                :success-messages="successMessages">
          </shared-page-messages>
        </div>

          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-subtitle-2">Name</th>
                  <th class="text-subtitle-2">Relationship</th>
                  <th class="text-subtitle-2">Country</th>
                  <th class="text-subtitle-2">Status</th>
                  <th class="text-subtitle-2">Updated</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="dependent in dependents"
                  :key="dependent.id"
                >
                  <td>
                    <router-link :to="{name: 'edit_dependent', params: {id: dependent.id}}">
                      {{ dependent.firstName }} {{ dependent.middleName }} {{ dependent.lastName }}
                    </router-link>
                  </td>
                  <td>{{ dependent.relationType.name }}</td>
                  <td>{{ dependent.country }}</td>
                  <td>{{ dependentStatusMap[dependent.status] }}</td>
                  <td>{{ dependent.updated | formatDate }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>


      </base-material-card>


    </v-container>

  </v-main>
</template>

<script>
import api from '@/services/api'
import geoUtils from '@/utils/geography'
import constants from '@/utils/constants'
import {mapGetters} from "vuex";
import SharedPageMessages from '@/views/components/shared/PageMessages.vue'

export default {
  name: 'CoreViewDependentsView',
  components: {SharedPageMessages},

  created() {
    this.$gtag.event('view_dependents')

    this.userId = this.getUserId
    this.fetchDependents()
  },

  computed: {
    ...mapGetters({
      getUserId: 'getUserId'
    }),
    computedCountry: {
      get() {
        return geoUtils.findCountryByCode(this.user.country)
      },
      set(value) {
        this.user.country = value
      }
    }
  },

  methods: {
    fetchDependents() {
      api
          .fetchDependents(this.userId)
          .then(response => {
            this.dependents = response.data
          })
          .catch(err => {
            this.handleError(err)
          })
    },
    handleError(err) {
      let errorMessage = api.parseResponseError(err)
      this.errorMessages.push(errorMessage)
    }
  },

  data() {
    return {
      errorMessages: [],
      successMessages: [],
      warningMessages: [],
      userId: null,
      user: {
        country: 'US',
        idType: {}
      },
      dependents: [],
      dependentStatusMap: constants.getDependentStatusMap()
    }
  }
}
</script>
